import { Skeleton, Box } from "@mui/material";

export function AnalysisModalSkeleton() {
  return (
    <Box>
      {[...Array(3)].map((_, rowIndex) => (
        <Box key={rowIndex} display="flex" mb={2}>
          {[...Array(4)].map((_, colIndex) => (
            <Skeleton
              key={colIndex}
              variant="rectangular"
              width="23%"
              height={40}
              style={{ marginRight: colIndex < 3 ? 16 : 0 }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
}